import { IDefaultService } from "../default-service/default-service.interface";
import { IRevisionHistory } from "./revision-history.interface";

export interface IServicesByDealer {
  revisionHistory: IRevisionHistory[];
  offeredServices: IDefaultService[];
}
